
import { Button, cn, SubSidebar } from 'twyne-new.ui';

import { useAppLayoutContext } from './context';
import { useCollapseOnMobile } from './hooks';

export default function AppSidebarFilters({ children, className = '' }) {
  const { filterCollapsed, setFilterCollapsed } = useAppLayoutContext()
  useCollapseOnMobile({ setCollapsed: setFilterCollapsed })

  return <SubSidebar
    collapsed={filterCollapsed}
    onClickCollapse={() => setFilterCollapsed(filterCollapsed => !filterCollapsed)}
    className={cn(className)}
  >
    <div className='grid grid-cols-2 items-center'>
      <h1 className='text-lg flex-row twy-text-base-accent'>
        Filters
      </h1>
      {!filterCollapsed && children}
    </div>
  </SubSidebar>
}

export function ResetFiltersButton({ onReset }) {
  return <div className='justify-self-end'>
    <Button size='sm' variant='outline' color='accent' onClick={onReset}>
      Reset
    </Button>
  </div>
}
